import * as yup from 'common/yup';
import {
   ReportRelativeTimeRangeType,
   ReportRelativeTimeRangeTypeNames,
} from 'types/diplomat/reports/ReportRelativeTimeRangeType';
import {ReportFormatChooserType} from './ReportFormatChooserType';

export const CommonReportParamsNames = {
   allRecords: 'allRecords',
   byDate: 'byDate',
   fromDate: 'fromDate',
   toDate: 'toDate',
} as const;

export const CommonReportParams = yup
   .object({
      [CommonReportParamsNames.allRecords]: yup.bool(),
      [CommonReportParamsNames.byDate]: yup.bool(),
      [CommonReportParamsNames.fromDate]: yup
         .date()
         .when([CommonReportParamsNames.byDate, ReportRelativeTimeRangeTypeNames.relativeDate], {
            is: (byDate, relative) => byDate && !relative,
            then: (schema: yup.DateSchema<Date>) => schema.required(),
         }),
      [CommonReportParamsNames.toDate]: yup
         .date()
         .when([CommonReportParamsNames.byDate, ReportRelativeTimeRangeTypeNames.relativeDate], {
            is: (byDate, relative) => byDate && !relative,
            then: (schema: yup.DateSchema<Date>) => schema.required(),
         }),
   })
   .concat(ReportRelativeTimeRangeType)
   .concat(ReportFormatChooserType);

export type ICommonReportParams = yup.InferType<typeof CommonReportParams>;
